import { useSyncExternalStore } from 'react'
import { initialFinancialTransactionsTab } from './ContactFinancialTransactionsSection'
import { pushLocation, subscribeLocation } from './timelineFilters'

export function useContactProfileTab(availableTabs: readonly string[]) {
  const requestedTab = useSyncExternalStore(
    subscribeLocation,
    () =>
      new URLSearchParams(window.location.search).get('tab') ?? initialFinancialTransactionsTab(),
  )
  const initialTab = initialFinancialTransactionsTab()
  const activeTab = availableTabs.includes(requestedTab)
    ? requestedTab
    : availableTabs.includes(initialTab)
      ? initialTab
      : 'profile'
  const setActiveTab = (tab: string) => {
    const url = new URL(window.location.href)
    url.searchParams.set('tab', tab)
    pushLocation(url)
  }
  return [activeTab, setActiveTab] as const
}
